<template>
  <div class="animated fadeIn">
    <b-row>
      <b-col sm="12">
        <transition name="fade">
          <b-card no-body>
            <div slot="header">
              No Strike List
              <div class="card-header-actions">
                <!-- <b-link href="#" class="card-header-action btn-setting">
                  <i class="icon-settings"></i>
                </b-link>
                <b-link class="card-header-action btn-minimize" v-b-toggle.collapse1>
                  <i class="icon-arrow-up"></i>
                </b-link>
                <b-link href="#" class="card-header-action btn-close" v-on:click="show = !show">
                  <i class="icon-close"></i>
                </b-link> -->
              </div>
            </div>
            <b-collapse id="collapse1" visible>
              <b-card-body>
                <no-strike-list></no-strike-list>
              </b-card-body>
            </b-collapse>
          </b-card>
        </transition>
        <!-- <b-card header="Notification Requests">
            <request-table></request-table>
        </b-card> -->
      </b-col>
    </b-row>
  </div>
</template>

<script>
import * as utils from '@/mixins/utils'
import * as types from '@/store/types'
import * as constants from '@/store/constants'
import { mapGetters } from 'vuex'
import ReceivedChart from '@/components/dashboard/ReceivedChart'
import SubmittedChart from '@/components/dashboard/SubmittedChart'
import PendingEhocChart from '@/components/dashboard/PendingEhocChart'
import PendingAgencyChart from '@/components/dashboard/PendingAgencyChart'
import CancelledChart from '@/components/dashboard/CancelledChart'

import DashboardChart from '@/components/dashboard/DashboardChart'

import CardLine2ChartExample from '@/components/dashboard/CardLine2ChartExample'
import CardLine3ChartExample from '@/components/dashboard/CardLine3ChartExample'
import CardBarChartExample from '@/components/dashboard/CardBarChartExample'
import MainChartExample from '@/components/dashboard/MainChartExample'
import SocialBoxChartExample from '@/components/dashboard/SocialBoxChartExample'
import CalloutChartExample from '@/components/dashboard/CalloutChartExample'
import { Callout } from '@coreui/vue'
import NoStrikeList from '@/components/list/NoStrikeList.vue'

export default {
  name: 'dashboard',
  components: {
    Callout,
    ReceivedChart,
    SubmittedChart,
    PendingEhocChart,
    PendingAgencyChart,
    CancelledChart,
    NoStrikeList,
    DashboardChart,
  },
  computed: {
    ...mapGetters({     
      statistics: types.GET_DASHBOARD_STATISTICS
    })
  },
  data: function () {
    return {     
    }
  },
  methods: {
    getColor: function(value) {
      let obj = this.$_.find(constants.STATUS_COLOR_CODES, {id:value})
      return obj.color;
    }
  },
  mounted () {
      this.$store.dispatch(types.ACTION_DASHBOARD_STATISTICS, constants.AGENCY_ADMIN)
  }
}
</script>

<style>
  /* IE fix */
  #card-chart-01, #card-chart-02 {
    width: 100% !important;
  }
</style>



// WEBPACK FOOTER //
// src/components/reports/NoStrikeListReport.vue